import { render } from "./UpdateAppBanner.vue?vue&type=template&id=96f00d62&scoped=true"
import script from "./UpdateAppBanner.vue?vue&type=script&lang=js"
export * from "./UpdateAppBanner.vue?vue&type=script&lang=js"

import "./UpdateAppBanner.vue?vue&type=style&index=0&id=96f00d62&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96f00d62"]])

export default __exports__